export class OrderRule {
    field;
    direction;
    _setDirection;
    index;
    _setIndex;
    firstDirection;

    constructor(field, params) {
        this.field = field;
        this.firstDirection = params.firstDirection;
        [this.direction, this._setDirection] = params.direction;
        [this.index, this._setIndex] = params.index;
    }

    setDirection(direction) {
        this.direction = direction;
        this._setDirection(direction);
    }

    setIndex(index) {
        this.index = index;
        this._setIndex(index);
    }
}

export class OrdersBundle {
    ordersDict = new Map();
    orders = [];
    _setOrders;

    constructor(fields, sortOrders, setOrders) {
        this._setOrders = setOrders;
        for (const [field, params] of Object.entries(fields)){
            this.ordersDict.set(field, new OrderRule(field, params));
        }
        const params =  sortOrders.length >0 ? JSON.parse(sortOrders) : [];
        for (const {fieldName, sortMode} of params){
            const role = this.ordersDict.get(fieldName);
            role.direction = sortMode.toLowerCase();
            this.orders.push(role)
            role.index = this.orders.length;
        }
    }

    applyOrder() {
        this._setOrders(JSON.stringify(this.orders.map(p => ({ fieldName: p.field, sortMode: p.direction.toUpperCase() }))));
    }

    getRule(field){
        return this.ordersDict.get(field);
    }

    setOrder(field, direction) {
        const rule = this.ordersDict.get(field);
        if(rule.direction === direction) return;
        rule.setDirection(direction);
        if(rule.index === 0) {
            this.orders.push(rule);
            rule.setIndex(this.orders.length);
        }
        if (direction === 'none'){
            rule.setIndex(0);
            this.orders.splice(this.orders.indexOf(rule), 1);
            for (let i = 0; i < this.orders.length; i++){
                this.orders[i].setIndex(i + 1);
            }
        }
        this.applyOrder();
    }

    toggleField(field) {
        const rule = this.ordersDict.get(field);
        if (rule.direction === 'none') this.setOrder(field, rule.firstDirection);
        else if (rule.direction === rule.firstDirection) this.setOrder(field, rule.firstDirection === 'asc' ? 'desc' : 'asc');
        else this.setOrder(field, 'none');
    }
}